import React from "react";
import { Trans, useTranslation } from "react-i18next";

const Title = () => {
    const { t } = useTranslation();

    return (
        <div className={"conditional_rebates_title"}>
            <Trans i18nKey={"ConditionalRebates.Title"} t={t} />
        </div>
    );
};

export default Title;
